:host {
  display: contents;
}

.mouse-position {
  position: fixed;
  pointer-events: none;
}